import NewResponseForm from './NewResponseForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useParams } from 'react-router-dom'
import { useGetTasksQuery } from '../tasks/tasksApiSlice'
const NewResponse = () => {
    useTitle('geshtop-Exercise: New Response')
    const {  taskId } = useParams()
    const { task } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            task: data?.entities[taskId]
        }),
    })

    if ( !task) return <PulseLoader color={"#FFF"} />

    const content = <NewResponseForm task={task}/>

    return content
}
export default NewResponse